import { render, staticRenderFns } from "./SlideDetailRealisasi.vue?vue&type=template&id=f52a2e78"
import script from "./SlideDetailRealisasi.vue?vue&type=script&lang=js"
export * from "./SlideDetailRealisasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports